







import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import Login from "@/components/landing/common/Login.vue";
import RestorePassword from "@/components/landing/common/RestorePassword.vue";
import BecomeClient from "@/components/landing/common/BecomeClient.vue";
import RouteNames from "@/router/RouteNames";

const Auth = namespace("Auth");

type mode = 'Login' | 'RestorePassword' | 'BecomeClient';

@Component({
  components: {
    Login,
    RestorePassword,
    BecomeClient,
  }
})
export default class LoginPage extends Vue {

  @Auth.Getter
  private isLoggedIn!: boolean;

  private mode: mode  = 'Login';

  created(): void {
    if (this.isLoggedIn) {
      this.$router.push({ name: RouteNames.HOME });
    }
  }

  private toggleMode(value: mode): void {
    this.mode = value;
  }
}
